import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles } from '@knockrentals/knock-shared-web';
import SelectedPropertiesFilter from './SelectedPropertiesFilter';
import BulkUpdateMenu from './BulkUpdateMenu';

const useStyles = makeStyles({
  propertiesChip: {
    backgroundColor: '#ededf2',
    fontSize: '13px',
    marginRight: '16px',
  },
  tableToolbar: {
    borderBottom: '1px solid #e0e0e0',
    padding: '13px 16px',
  },
});

const TableToolbar = ({
  filteredPropertyIds,
  handleBulkSettingsUpdate,
  handleFilterProperties,
  properties,
  selectedProperties,
}) => {
  const classes = useStyles();
  const count = selectedProperties.length;
  return (
    <Box
      alignItems="center"
      className={classes.tableToolbar}
      display="flex"
      justifyContent="space-between"
    >
      <SelectedPropertiesFilter
        filteredPropertyIds={filteredPropertyIds}
        handleFilterProperties={handleFilterProperties}
        properties={properties}
      />
      <BulkUpdateMenu
        count={count}
        handleBulkSettingsUpdate={handleBulkSettingsUpdate}
      />
    </Box>
  );
};

TableToolbar.propTypes = {
  filteredPropertyIds: PropTypes.arrayOf(PropTypes.number),
  handleBulkSettingsUpdate: PropTypes.func,
  handleFilterProperties: PropTypes.func,
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      aiEmailEnabled: PropTypes.string,
      emailProductEnabled: PropTypes.string,
      genAiEmailEnabled: PropTypes.string,
      leasingEnabled: PropTypes.bool,
      propertyId: PropTypes.number.isRequired,
      propertyName: PropTypes.string.isRequired,
      residentEnabled: PropTypes.bool,
      tableData: PropTypes.shape({
        id: PropTypes.number,
      }),
    }),
  ).isRequired,
  selectedProperties: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default TableToolbar;
